'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = require('./Avatar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Avatar/index.js
// module id = 3031
// module chunks = 0